/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { Link, useHistory } from "react-router-dom";
import { sortCaret, toAbsoluteUrl } from "../../../_helpers";
import * as columnFormatters from "../../../../app/modules/ECommerce/pages/products/products-table/column-formatters/StatusColumnFormatter";
import { useTranslation } from "react-i18next";
import {
  Button,
  Dropdown,
  Modal,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { DropdownCustomToggler } from "../../dropdowns";
import SVG from "react-inlinesvg";
import { InvoiceForm } from "../../../../app/modules/ECommerce/pages/products/products-table/column-formatters/InvoicePdf";
import Swal from "sweetalert2";
import low from "lowdb";
import LocalStorage from "lowdb/adapters/LocalStorage";
import { translateAuto } from "../../../_helpers/AtHelper";
const adapter = new LocalStorage("db");
const db = low(adapter);
export function TableLoadWidget({
  className,
  entities,
  loadingData,
  setstatusSelected,
  statusSelected,
  getDachboardLoads,
  getchartDate,
  setSortOption,
  SortOption,
}) {
  const history = useHistory();

  const { t } = useTranslation();
  const UpdateBulling = ({ row }) => {
    const [showModalInvoice, setshowModalInvoice] = useState(false);
    const { t } = useTranslation();
    return (
      <>
        <li className="navi-item">
          <p
            className="navi-link mb-0"
            onClick={() => {
              setshowModalInvoice(true);
            }}
          >
            <span className="svg-icon svg-icon-md svg-icon-danger mr-2">
              <i className="fas fa-file-invoice text-success"></i>
            </span>
            <span className="navi-text">{t("Print") + " " + t("invoice")}</span>
          </p>
        </li>
        <Modal
          size="xl"
          show={showModalInvoice}
          onHide={() => {
            setshowModalInvoice(false);
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {t("Invoice")}: {row.Code}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <InvoiceForm row={row} />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                setshowModalInvoice(false);
              }}
            >
              {"Close"}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  };
  const columns = [
    {
      dataField: "id",
      text: "#",
      sort: true,
      sortCaret: sortCaret,
      formatter: (cell, row) => {
        return (
          <Dropdown className="dropdown-inline position-unset" alignRight>
            <Dropdown.Toggle
              as={DropdownCustomToggler}
              id="dropdown-toggle-top"
            >
              <i className="ki ki-bold-more-hor" />
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu dropdown-menu-sm dropdown-menu-right">
              <ul className="navi navi-hover py-5">
                {row.StatusCode === "OP" ||
                row.StatusCode === "DF" ||
                row.StatusCode === "" ? (
                  <li className="navi-item">
                    <Link
                      className="navi-link"
                      to={`/shipper/Loads/${row.Id}/edit`}
                    >
                      <span className="svg-icon svg-icon-md svg-icon-primary mr-2">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Write.svg"
                          )}
                        />
                      </span>

                      <span className="navi-text">{t("Edit")}</span>
                    </Link>
                  </li>
                ) : (
                  ""
                )}
                <li className="navi-item">
                  <Link
                    className="navi-link"
                    to={`/shipper/Loads/${row.Id}/details`}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-primary mr-2">
                      <SVG
                        src={toAbsoluteUrl("/media/svg/icons/Files/File.svg")}
                      />
                    </span>
                    <span className="navi-text">{t("Detail")}</span>
                  </Link>
                </li>
                <li className="navi-item">
                  <a
                    className="navi-link"
                    style={
                      row.DraftReadonly
                        ? { pointerEvents: "none", opacity: "0.5" }
                        : { pointerEvents: "auto", Opacity: "1" }
                    }
                    onClick={() => {
                      if (row.DraftReadonly) {
                        return;
                      }
                      var myHeaders = new Headers();
                      myHeaders.append(
                        "Authorization",
                        `Bearer ${db.read().getState()?.Token}`
                      );
                      myHeaders.append("Content-Type", "application/json");
                      myHeaders.append("Accept", "text/plain");
                      fetch(`${window.$apiurl}/api/Shipments/PostUnpost`, {
                        method: "post",
                        headers: myHeaders,
                        body: JSON.stringify({
                          ShipmentId: row.Id,
                          AsDraft: !row.IsDraft,
                        }),
                      })
                        .then(async (response) => {
                          const statusCode = await response.status;
                          const contentType = response.headers.get(
                            "content-type"
                          );
                          if (
                            contentType &&
                            contentType.indexOf("application/json") !== -1
                          ) {
                            return response
                              .json()
                              .then((data) => [statusCode, data]);
                          } else {
                            return response
                              .text()
                              .then((text) => [statusCode, { Message: "" }]);
                          }
                        })
                        .then((result) => {
                          if (result[0] === 200) {
                            // document.getElementById("textRefrech").click();
                            Swal.fire(
                              t("Great"),
                              !row.DraftReadonly
                                ? row.IsDraft
                                  ? t("Load_has_been_Posted_to_TaaP")
                                  : t("Load_has_been_removed_from_TaaP")
                                : t("Load_has_been_removed_from_TaaP"),
                              "success"
                            );
                            getDachboardLoads(
                              statusSelected?.StatusId,
                              SortOption
                            );
                            getchartDate();
                          } else {
                            if (
                              result[1].ModelState !== null &&
                              result[1].ModelState !== undefined &&
                              result[1].ModelState !== ""
                            ) {
                              let modelState = result[1].ModelState;
                              if (modelState)
                                Object.keys(modelState).forEach(function(k) {
                                  modelState[k].forEach((element) => {
                                    Swal.fire(
                                      translateAuto("Error"),
                                      translateAuto(element)
                                    );
                                  });
                                });
                            } else if (
                              result[1].Message !== null &&
                              result[1].Message !== undefined &&
                              result[1].Message !== ""
                            ) {
                              Swal.fire(
                                translateAuto("Error"),
                                translateAuto(result[1].Message),
                                "error"
                              );
                            } else if (
                              result[1].error_description !== null &&
                              result[1].error_description !== undefined &&
                              result[1].error_description !== ""
                            ) {
                              Swal.fire(
                                translateAuto("Error"),
                                translateAuto(result[1].error_description),
                                "error"
                              );
                            } else {
                              Swal.fire(
                                translateAuto("Error"),
                                t("Bad_Request")
                              );
                            }
                          }
                        })
                        .catch((error) => {
                          Swal.fire(
                            translateAuto("Error"),
                            translateAuto(error),
                            "error"
                          );
                        });
                    }}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-primary mr-2">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Devices/iPhone-X.svg"
                        )}
                      />
                    </span>
                    <span className="navi-text ">
                      {!row.DraftReadonly
                        ? row.IsDraft
                          ? translateAuto("Post_to_TaaP")
                          : translateAuto("Remove_from_TaaP")
                        : translateAuto("Remove_from_TaaP")}
                    </span>
                  </a>
                </li>
                {row.Status !== "Draft" &&
                  row.Status !== "" &&
                  row.Status !== undefined &&
                  row.Status !== null && (
                    <li className="navi-item">
                      <Link
                        className="navi-link"
                        to={`/trackload/${row.Id}/details`}
                      >
                        <span className="svg-icon svg-icon-md svg-icon-danger mr-2">
                          <i className="fas fa-map text-info"></i>
                        </span>
                        <span className="navi-text">{t("Track_Load")}</span>
                      </Link>
                    </li>
                  )}
                  <UpdateBulling row={row} />
              </ul>
            </Dropdown.Menu>
          </Dropdown>
        );
      },
    },
    {
      dataField: "Id",
      text: t("Load_id"),
      sort: true,
      sortCaret: sortCaret,
      formatter: (cell, row) => {
        return (
          <p
            style={{ WebkitUserSelect: "text" }}
            onClick={() => {
              if (
                row.Status !== "Draft" &&
                row.Status !== "" &&
                row.Status !== undefined &&
                row.Status !== null
              ) {
                history.push(`/trackload/${row.Id}/details`);
              } else {
                history.push(`/shipper/Loads/${row.Id}/edit`);
              }
            }}
            className="btn btn-link font-weight-bolder text-primary text-decoration-none pl-0"
          >
            {row.Code}
          </p>
        );
      },
    },
    {
      dataField: "Mode",
      text: t("Mode"),
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "FromCity",
      text: t("PU_CITY_ST"),
      sort: true,
      sortCaret: sortCaret,
      formatter: (cell, row) => {
        return row.FromCity !== null &&
          row.FromCity !== undefined &&
          row.FromCity !== ""
          ? row.FromCity + "/" + row.FromState
          : "";
      },
    },
    {
      dataField: "ToCity",
      text: t("DEL_City_st"),
      sort: true,
      sortCaret: sortCaret,
      formatter: (cell, row) => {
        return row.ToCity !== null &&
          row.ToCity !== undefined &&
          row.ToCity !== ""
          ? row.ToCity + "/" + row.ToState
          : "";
      },
    },
    {
      dataField: "Stops",
      text: t("Stops"),
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "WeightType",
      text: t("Weight_Type"),
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "TotalWeight",
      text: t("Total_Weight"),
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "EquipmentType",
      text: t("Equipments"),
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "Alert",
      text: t("Alert"),
      sort: true,
      sortCaret: sortCaret,
      formatter: (cell, row) => {
        return row.Alert !== null &&
          row.Alert !== undefined &&
          row.Alert !== "" ? (
          <OverlayTrigger
            overlay={
              <Tooltip
                style={{ pointerEvents: "none" }}
                id="products-delete-tooltip"
              >
                {row.Alert}
              </Tooltip>
            }
          >
            <i className="fa fa-exclamation-triangle text-danger"></i>
          </OverlayTrigger>
        ) : (
          ""
        );
      },
    },
    {
      dataField: "Status",
      text: t("Status"),
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.StatusColumnFormatter,
    },
  ];
  const GetHandlerTableChange = (type, newState) => {
    if (type === "sort") {
      let values = { ...SortOption };
      values.sortField = newState.sortField;
      values.sortOrder = newState.sortOrder;
      getDachboardLoads(statusSelected?.StatusId, values);
    }
  };
  return (
    <div className={`card card-custom ${className}`}>
      {/* begin::Header */}
      <div className="card-header border-0 py-5">
        <h3 className="card-title align-items-start align-self-center flex-column">
          <span className="card-label font-weight-bolder text-dark">
            {statusSelected?.Name !== undefined &&
            statusSelected?.Name !== null &&
            statusSelected?.Name !== ""
              ? `${statusSelected?.Name} `
              : "Latest "}
            {t("Latest_Loads")}
          </span>
        </h3>
        <div className="card-toolbar">
          {statusSelected !== "" ? (
            <button
              className="btn btn-info font-weight-bolder font-size-sm mr-3"
              onClick={() => {
                getchartDate();

                setstatusSelected("");
                getDachboardLoads("", SortOption);
              }}
            >
              Clear Filter
            </button>
          ) : (
            ""
          )}
          <Link
            to={"/shipper/Loads/new"}
            className="btn btn-primary font-weight-bolder font-size-sm"
          >
            {t("Post_Load")}
          </Link>
        </div>
      </div>
      {/* end::Header */}

      {/* begin::Body */}
      <div className="card-body py-0">
        {/* begin::Table */}
        <div className="table-responsive">
          <BootstrapTable
            wrapperClasses="table-responsive"
            classes="table table-head-custom table-vertical-center overflow-hidden"
            bootstrap4
            noDataIndication={
              loadingData === true ? (
                <h4 style={{ textAlign: "center" }}>Loading ...</h4>
              ) : (
                <h4 style={{ textAlign: "center" }}>
                  {"There is no data available at the moment"}.
                </h4>
              )
            }
            bordered={false}
            remote
            onTableChange={GetHandlerTableChange}
            keyField="Id"
            data={entities === null ? [] : entities}
            columns={columns}
          ></BootstrapTable>
        </div>
        {/* end::Table */}
      </div>
      {/* end::Body */}
    </div>
  );
}
